import '../_mixins/catalog/catalog-autoload';
import {articles_box} from '../_mixins/articles/slider-box';
import {init_faq} from '../_mixins/faq/faq';
import {init_reviews_slider} from '../../mixins/public/init-reviews-slider';

console.log('catalog/index.js loaded: ', Math.round(performance.now()))

init_faq()
init_reviews_slider()
articles_box.init_slider()

console.log('catalog/index.js end file: ', Math.round(performance.now()))
